var render, staticRenderFns
import script from "./CompanyEditForm.vue?vue&type=script&lang=js&"
export * from "./CompanyEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a3c74f')) {
      api.createRecord('53a3c74f', component.options)
    } else {
      api.reload('53a3c74f', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Company/resources/vue/CompanyEditForm.vue"
export default component.exports